/* Tusq v63.28 (2026-10-06) — Dual-checkout CTA for in-app webview users.
 *
 * Problem: 53.83% of Tusq traffic is Facebook / Instagram in-app webview
 * where Shop Pay / Apple Pay / Google Pay buttons silently fail at the
 * Shopify checkout page. Clarity shows Reached-Checkout → Purchase at
 * 45.5% (vs 60-70% industry).
 *
 * Fix: offer BOTH options. Keep the standard Checkout button for users who
 * want to stay in-app. Add a secondary "Open in Safari" link that reopens
 * the cart in real Safari (iOS) or Chrome (Android) where all payment
 * methods work. We hand off cart state via Shopify's /cart/{variantId}:{qty}
 * permalink pattern so the fresh browser session arrives with the same cart.
 *
 * iOS deep-link: x-safari-https:// prefix forces Safari launch from any
 *                webview that respects URL schemes (FB, IG, Twitter, Threads).
 * Android deep-link: intent:// with chrome package + https fallback.
 */
(function(){
  'use strict';

  var ua = navigator.userAgent || '';
  var isFBApp     = /FBAN|FBAV/.test(ua);
  var isInstagram = /Instagram/.test(ua);
  var isThreads   = /Barcelona/.test(ua);              // Threads webview UA
  var isLinkedIn  = /LinkedInApp/.test(ua);
  var isTikTok    = /BytedanceWebview|musical_ly/.test(ua);
  var isTwitter   = /Twitter/.test(ua);
  var isWebview   = isFBApp || isInstagram || isThreads || isLinkedIn || isTikTok || isTwitter;

  if (!isWebview) return;

  var isIOS     = /iPhone|iPad|iPod/.test(ua);
  var isAndroid = /Android/.test(ua);

  var host = window.location.host; // tusqapparel.com

  async function buildSafariUrl(){
    var path = '/cart';
    try {
      var r = await fetch('/cart.js', { credentials: 'same-origin' });
      if (r.ok) {
        var cart = await r.json();
        if (cart && cart.items && cart.items.length) {
          var items = cart.items.map(function(i){
            return i.variant_id + ':' + i.quantity;
          }).join(',');
          // Shopify permalink: /cart/{variantId}:{qty},{variantId}:{qty}
          // ?checkout=1 auto-redirects to the checkout page on arrival.
          path = '/cart/' + items + '?checkout=1';
        }
      }
    } catch(e) { /* fall back to generic /cart link */ }

    var httpsUrl = 'https://' + host + path;

    if (isIOS) {
      // x-safari-https:// launches Safari with the given URL on iOS 13+
      return 'x-safari-https://' + host + path;
    }
    if (isAndroid) {
      // intent:// opens Chrome; browser_fallback_url catches older devices
      return 'intent://' + host + path +
             '#Intent;scheme=https;package=com.android.chrome;' +
             'S.browser_fallback_url=' + encodeURIComponent(httpsUrl) + ';end';
    }
    return httpsUrl;
  }

  function wireButton(btn){
    if (!btn || btn.__tusqWired) return;
    btn.__tusqWired = true;
    btn.hidden = false;

    btn.addEventListener('click', async function(e){
      e.preventDefault();
      // Build URL at click-time so we always get the freshest cart.
      var url = await buildSafariUrl();
      // Fire-and-forget: on iOS the x-safari-https hand-off may replace the
      // tab; on Android the intent URL opens Chrome and keeps the FB app open.
      try { window.location.href = url; } catch(err){}
    });
  }

  function init(){
    // Cart drawer button (lives permanently in DOM, but may be re-rendered
    // on cart updates — scan every time the drawer opens).
    var cartBtn = document.getElementById('CartDrawer-SafariCheckout');
    wireButton(cartBtn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-wire after Shopify re-renders the cart section (variant swap, qty
  // change, add-to-cart).
  document.addEventListener('cart:updated', init);
  document.addEventListener('cart:refresh', init);
})();
